<template>
  <Backdrop>
    <div class="faker" @click="close"></div>
    <div class="ccontainer">

      <div class="vertical">
        <Header :model="model" :post="element" :showChat="showChat" />

        <Carousel 
          v-if="showCarousel & false"
          :postData="postData"
          :postContent="postContent"
          :model="model"
          :VideoElementHandler="VideoElementHandler"
        />
        <Simple 
          v-else
          :postData="postData"
          :postContent="postContentSimple"
          :model="model"
          :VideoElementHandler="VideoElementHandler"
        />

        <PreviewDescription :post="element" :model="model" />
      </div>

    </div>
  </Backdrop>
</template>
<script>
import Carousel from "./Carousel.vue";
import Simple from "./Simple.vue";

import Backdrop from "../Modal/Backdrop.vue";
import PreviewDescription from "./Preview/Description.vue";
import Header from "./Preview/Header.vue";

export default {
  name: "ModalSorter",
  components: {
    Backdrop,
    Header,
    Carousel,
    Simple,
    PreviewDescription,
    Header
},
  props: {
    element: {},
    model: {},
    VideoElementHandler: {},
    showChat: {
      type: Boolean,
      default: false,
      required: false,
    },
  },
  methods: {
    close() {
      this.$emit("close");
    },
  },
  computed: {
    isCarousel() {
      return this.element && this.element.content && this.element.content.length > 1;
    },
    showCarousel() {
      return this.isCarousel && this.viewMode !== "grid";
    },
    postContent() {
      if (this.element.content) {
        return this.element.content;
      }

      return this.element;
    },
    postData() {
      // Duplicate thos.element
      const data = { ...this.element };

      if (data.content) {
        if (data.content.length) {
          data.qElements = data.content.length;
        } else {
          data.qElements = 1;
        }

        delete data.content;
      }

      return data;
    },
    postContentSimple() {
      return this.postContent[0];
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../styles/variables.scss";

.faker {
  height: 100%;
  width: 100%;
  position: absolute;
  z-index: 1;
  background-color: rgba(0, 0, 0, 0.5);
}

.ccontainer {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  padding-inline: 2em;
  margin-block: 2em;
  z-index: 99;
  max-width: 600px;

  .vertical {
    background-color: var(--background_03);
    border-radius: 10px;
    width: 100%;
  }
}
</style>
